export class CooListRequest {
    body: CooListBody = new CooListBody();
}

export class CooListBody {
    ProcessName: string = "DC Get COO List WF";
    IncomingHierarchy: IncomingHierarchy = new IncomingHierarchy();
    Language: string = "ENU";
    PageSize: string = "2";
    StartRowNum: number = 0;
    NewQuery: any = "true";
    NoDays: string = "100";
}

export class IncomingHierarchy {
    MessageId: string = "";
    IntObjectName: string = "DCCOOListIO";
    MessageType: string = "Integration Object";
    IntObjectFormat: string = "Siebel Hierarchical";
    ListOfDCCOOListIO: ListOfDCCOOListIO = new ListOfDCCOOListIO();
}

export class ListOfDCCOOListIO {
    "DC COO SR Thin BC": DCCOOSRThinBC = new DCCOOSRThinBC();
}

export class DCCOOSRThinBC {
    "Account Number": string = "";
    "DC COO Number": string = "";
    "SR Number": string = "";
}
